function fromEntries(iterable){return[].concat(iterable).reduce((function(obj,_ref){var key=_ref[0],val=_ref[1];return obj[key]=val,obj}),{})}export{fromEntries};
